/* KHERAJANI COMPUTERS extra behaviour: help panel, PDP lightbox/swipe/sticky bar, sort tidy, RTL fallback. Original, dependency-free. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function money(v) {
    try {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AED';
      if (cur === 'AED') { var pp = parseFloat(v).toFixed(2).split('.'); return '⃃ ' + pp[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (pp[1] === '00' ? '' : '.' + pp[1]); }
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(parseFloat(v));
    } catch (e) { return v; }
  }
  function shortTitle(t) {
    t = (t || '').split(' [')[0].split(' | ')[0];
    t = t.replace(/ in Dubai/g, '').replace(/ Dubai/g, '').replace(/ ?Camcity/gi, '');
    var d = 0, c = -1, i, ch, cut = false, closed = false;
    for (i = 0; i < t.length; i++) { ch = t.charAt(i); if (ch === '(') d++; else if (ch === ')') d = Math.max(0, d - 1); else if (ch === ',' && d === 0 && t.charAt(i + 1) === ' ') { c = i; break; } }
    if (c > 12) t = t.slice(0, c);
    t = t.trim();
    if (t.length > 62) { t = t.slice(0, 62); t = t.slice(0, Math.max(t.lastIndexOf(' '), 30)); cut = true; }
    if ((t.match(/\(/g) || []).length > (t.match(/\)/g) || []).length) {
      var k = t.lastIndexOf(', ');
      if (k > t.lastIndexOf('(')) { t = t.slice(0, k) + ')'; closed = true; } else { t = t.replace(/\s*\([^)]*$/, ''); cut = true; }
    }
    t = t.replace(/[\s,;:\-–]+$/, '');
    return cut && !closed ? t + '…' : t;
  }

  /* ---------- RTL fallback: only when an Arabic locale is active ---------- */
  try {
    var loc = (window.Shopify && window.Shopify.locale) || root.lang || '';
    if (/^(ar|he|fa|ur)/i.test(loc) && !root.getAttribute('dir')) root.setAttribute('dir', 'rtl');
  } catch (e) {}

  /* ---------- help / WhatsApp panel ----------
     Data sources are real: Shopify predictive search for products, fixed confirmed facts in the markup.
     A future AI provider can be attached by setting window.KHC_ASSIST_ENDPOINT (not set = no AI is claimed or used). */
  function initAssist() {
    var a = $('[data-khc-assist]');
    if (!a || a.getAttribute('data-ready')) return;
    a.setAttribute('data-ready', '1');
    var fab = $('.khc-assist__fab', a), panel = $('.khc-assist__panel', a);
    var input = $('input[type=search]', a), res = $('.khc-as__res', a);
    var timer, ctl, last = '';
    function set(open) {
      a.classList.toggle('is-open', open);
      fab.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) { setTimeout(function () { panel.focus({ preventScroll: true }); }, 40); }
    }
    fab.addEventListener('click', function () { set(!a.classList.contains('is-open')); });
    var x = $('[data-khc-as-close]', a);
    if (x) x.addEventListener('click', function () { set(false); fab.focus(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && a.classList.contains('is-open')) { set(false); fab.focus(); } });
    document.addEventListener('click', function (e) { if (a.classList.contains('is-open') && !a.contains(e.target)) set(false); });
    if (input && res) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q === last) return;
        last = q;
        timer = setTimeout(function () { run(q); }, 220);
      });
    }
    function run(q) {
      if (ctl && ctl.abort) ctl.abort();
      if (q.length < 2) { res.innerHTML = ''; return; }
      ctl = window.AbortController ? new AbortController() : null;
      var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
      var url = base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last';
      fetch(url, ctl ? { signal: ctl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var list = (((d || {}).resources || {}).results || {}).products || [];
          if (!list.length) { res.innerHTML = '<p class="khc-as__none">No matching products. Message us on WhatsApp and we will check for you.</p>'; return; }
          res.innerHTML = list.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
            return '<a class="khc-as__r" href="' + esc(p.url) + '"><span class="khc-as__ri">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="48" height="48">' : '') + '</span><span><span class="khc-as__rt">' + esc(shortTitle(p.title)) + '</span><span class="khc-as__rp">' + esc(money(p.price)) + '</span></span></a>';
          }).join('');
        })
        .catch(function (e) { if (e && e.name === 'AbortError') return; res.innerHTML = ''; });
    }
  }

  /* ---------- product page: lightbox, swipe, sticky add-to-cart ---------- */
  function initPdpExtra() {
    var pdp = $('[data-khc-pdp]');
    if (!pdp || pdp.getAttribute('data-x-ready')) return;
    pdp.setAttribute('data-x-ready', '1');
    var stage = $('.khc-stage', pdp);

    /* lightbox */
    var lb;
    function items() { return $$('.khc-stage__item', pdp).filter(function (i) { return i.querySelector('img'); }); }
    var idx = 0;
    function big(img) {
      var s = img.currentSrc || img.src || '';
      return s.replace(/width=\d+/, 'width=2000');
    }
    function build() {
      lb = document.createElement('div');
      lb.className = 'khc-lb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Product image viewer');
      lb.innerHTML = '<img class="khc-lb__img" alt="">' +
        '<button type="button" class="khc-lb__x" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<button type="button" class="khc-lb__p" aria-label="Previous image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<button type="button" class="khc-lb__n" aria-label="Next image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>' +
        '<span class="khc-lb__c" aria-live="polite"></span>';
      document.body.appendChild(lb);
      $('.khc-lb__x', lb).addEventListener('click', close);
      $('.khc-lb__p', lb).addEventListener('click', function () { go(-1); });
      $('.khc-lb__n', lb).addEventListener('click', function () { go(1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    }
    function show() {
      var list = items();
      if (!list.length) return;
      idx = (idx + list.length) % list.length;
      var im = $('img', list[idx]);
      var lim = $('.khc-lb__img', lb);
      lim.src = big(im);
      lim.alt = im.alt || '';
      $('.khc-lb__c', lb).textContent = (idx + 1) + ' / ' + list.length;
      var multi = list.length > 1;
      $('.khc-lb__p', lb).style.display = multi ? '' : 'none';
      $('.khc-lb__n', lb).style.display = multi ? '' : 'none';
    }
    function go(d) { idx += d; show(); }
    var opener;
    function open(i) {
      if (!lb) build();
      opener = document.activeElement;
      idx = i;
      show();
      root.classList.add('khc-lock');
      lb.classList.add('is-on');
      $('.khc-lb__x', lb).focus();
    }
    function close() {
      if (!lb) return;
      lb.classList.remove('is-on');
      root.classList.remove('khc-lock');
      if (opener && opener.focus) opener.focus();
    }
    if (stage) {
      stage.addEventListener('click', function (e) {
        var im = e.target.closest && e.target.closest('.khc-stage__item img');
        if (!im) return;
        var it = im.closest('.khc-stage__item');
        var i = items().indexOf(it);
        if (i > -1) open(i);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (!lb || !lb.classList.contains('is-on')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(root.getAttribute('dir') === 'rtl' ? -1 : 1);
      else if (e.key === 'ArrowLeft') go(root.getAttribute('dir') === 'rtl' ? 1 : -1);
    });

    /* swipe between images on touch devices */
    if (stage) {
      var sx = 0, sy = 0, tracking = false;
      stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; tracking = e.touches.length === 1; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
        var thumbs = $$('.khc-thumb', pdp);
        if (thumbs.length < 2) return;
        var cur = thumbs.findIndex(function (b) { return b.classList.contains('is-active'); });
        var next = cur + (dx < 0 ? 1 : -1);
        if (root.getAttribute('dir') === 'rtl') next = cur + (dx < 0 ? -1 : 1);
        if (next < 0 || next >= thumbs.length) return;
        thumbs[next].click();
      }, { passive: true });
    }

    /* sticky add-to-cart bar (small screens only, CSS hides it on desktop) */
    var atc = $('[data-khc-atc]', pdp), price = $('[data-khc-price]', pdp), h1 = $('h1', pdp), form = $('form', pdp);
    if (atc && price && form) {
      var bar = document.createElement('div');
      bar.className = 'khc-sticky';
      bar.innerHTML = '<div class="khc-sticky__p"><span class="khc-sticky__t"></span><span class="khc-sticky__v"></span></div><button type="button" class="khc-btn"></button>';
      document.body.appendChild(bar);
      var bt = $('.khc-btn', bar), bv = $('.khc-sticky__v', bar), bn = $('.khc-sticky__t', bar);
      bn.textContent = h1 ? h1.textContent.trim() : '';
      function sync() {
        bv.innerHTML = price.innerHTML;
        bt.textContent = atc.textContent.trim();
        bt.disabled = atc.disabled;
      }
      sync();
      new MutationObserver(sync).observe(atc, { attributes: true, childList: true, characterData: true, subtree: true });
      new MutationObserver(sync).observe(price, { childList: true, characterData: true, subtree: true });
      bt.addEventListener('click', function () {
        if (atc.disabled) return;
        if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
      });
      var footer = $('.khc-footer');
      var ticking = false;
      function apply() {
        ticking = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var ar = atc.getBoundingClientRect();
        var atcGone = ar.bottom < 0;
        var footVisible = footer ? footer.getBoundingClientRect().top < vh - 40 : false;
        var on = atcGone && !footVisible && window.innerWidth < 990;
        bar.classList.toggle('is-on', on);
        root.classList.toggle('khc-pdp-sticky-on', on);
      }
      function queue() { if (!ticking) { ticking = true; window.requestAnimationFrame(apply); } }
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      apply();
    }
  }

  /* ---------- collection: keep only sort options the store really supports and the brief lists ---------- */
  var HIDE_SORT = { relevance: 1, 'most-relevant': 1, 'title-descending': 1, 'created-ascending': 1 };
  function tidySort() {
    $$('select[name=sort_by]').forEach(function (s) {
      if (s.getAttribute('data-khc-sort')) return;
      if (/^\/search/.test(location.pathname)) return;
      s.setAttribute('data-khc-sort', '1');
      $$('option', s).forEach(function (o) {
        if (HIDE_SORT[o.value] && !o.selected) o.remove();
        else if (o.value === 'created-descending') o.textContent = 'Newest';
      });
    });
  }

  function init() {
    initAssist(); initPdpExtra(); tidySort();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (window.MutationObserver && $('select[name=sort_by]')) {
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(tidySort, 160); }).observe(document.body, { childList: true, subtree: true });
  }
})();
